var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LinkButton } from '@hn-ui/buttons';
import { Cancel } from '@hn-ui/icons';
import { styled } from 'styled-components';
var ScCancelBtn = styled(LinkButton).withConfig({ displayName: "ScCancelBtn", componentId: "sc-1i28df9" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  gap: 0 4px;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  color: ", ";\n  gap: 0 4px;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red40;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red40;
});
var CancelButton = function (_a) {
    var showIcon = _a.showIcon, props = __rest(_a, ["showIcon"]);
    return (_jsx(ScCancelBtn, __assign({}, props, { LeftIcon: function () { return (showIcon ? _jsx(Cancel, { size: 16, color: 'red50' }, void 0) : null); }, fit: true }, { children: _jsx("span", { children: "Cancel" }, void 0) }), void 0));
};
export { CancelButton };
var templateObject_1;
